// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"eff2ce7e","513":"2d7bf636","703":"82eaa1a4","787":"1517db73"}[chunkId] + ".chunk.js";
};